import WaLogin from '../mobile/login/WaLogin';
import S4_1_AdressedPropertiesList from '../mobile/propertiesList/S4_1_AdressedPropertiesList';
import S3_3_UnaddressedPropertiesList from '../mobile/propertiesList/S3_3_UnaddressedPropertiesList';
import { S3_1_PropertiesMap } from '../mobile/propertiesMap/S3_1_PropertiesMap';
import S1_2_RecoverySupportMenu from '../mobile/recoverySupportMenu/S1_2_RecoverySupportMenu';
import S4_2_SiteDetails from '../mobile/siteDetails/S4_2_SiteDetails';
import { WA_Screen } from './WardsScreens';
import WardsUnderConstruction from '../mobile/unavailable/WardsUnavailable';
import { ScreenDefinition } from 'src/ui/common/screens/ScreenDefinition';
import S4_2_1_StatusBulkChange from '../mobile/product/S4_2_1_StatusBulkChange';
import P_Main from '../desktop/P_Main';
import S4_3ProductDetails from '../mobile/product/details/S4_3ProductDetails';
import S4_3_1_EditProduct from '../mobile/product/S4_3_1_EditProduct';
import S6_1_ProgressCheck from '../mobile/filters/progressCheck/S6_1_ProgressCheck';
import S_ProductNumberList from '../mobile/product/list/S_ProductNumberList';
import S_TargetProductList from '../mobile/siteDetails/targetProductList/S_TargetProductList';
import S3_2_SearchFilter from '../mobile/filters/mapSearch/S3_2_SearchFilter';
import P5_1_UnaddressedPropertiesMap from '../desktop/components/P5_1/P5_1_UnaddressedPropertiesMap';
import P4_2_SiteDetails from '../desktop/components/P4_2/P4_2_SiteDetails';
import P6_3_DispatchOrderDetailScreen from '../desktop/components/P6_3/P6_3_DispatchOrderDetailScreen';
import P5_2_UnaddressedPropertiesList from '../desktop/components/P5_2/P5_2_UnaddressedPropertiesList';
import P4_2_UserSearch from '../desktop/components/P4_2/P4_2_UserSearch';
import { BusinessSummary } from '../desktop/components/summary/businessSummary/BusinessSummary';
import { BranchSummary } from '../desktop/components/summary/branchSummary/BranchSummary';

export const WaScreensMap: Record<WA_Screen, ScreenDefinition> = {
  [WA_Screen.UnderConstruction]: {
    key: WA_Screen.UnderConstruction,
    path: 'under-construction',
    mobileComponent: <WardsUnderConstruction />,
  },
  [WA_Screen.Login]: {
    key: WA_Screen.Login,
    path: 'login',
    mobileComponent: <WaLogin />,
  },
  [WA_Screen.WorkplacesMap]: {
    key: WA_Screen.WorkplacesMap,
    path: 'propertiesMap',
    mobileComponent: <S3_1_PropertiesMap />,
    desktopComponent: <P_Main component={<P5_1_UnaddressedPropertiesMap />} />,
  },
  [WA_Screen.WorkplaceDetails]: {
    key: WA_Screen.WorkplaceDetails,
    path: 'siteDetails',
    mobileComponent: <S4_2_SiteDetails />,
    desktopComponent: <P_Main component={<P4_2_SiteDetails />} />,
  },
  [WA_Screen.TargetProductList]: {
    key: WA_Screen.TargetProductList,
    path: 'targetProductList',
    mobileComponent: <S_TargetProductList />,
    desktopComponent: <P_Main component={<P4_2_SiteDetails />} />,
  },
  [WA_Screen.ProductList]: {
    key: WA_Screen.ProductList,
    path: 'productList',
    mobileComponent: <S_ProductNumberList />,
    desktopComponent: <P_Main component={<P4_2_SiteDetails />} />,
  },
  [WA_Screen.ProductDetails]: {
    key: WA_Screen.ProductDetails,
    path: 'productDetails',
    mobileComponent: <S4_3ProductDetails />,
    desktopComponent: <P_Main component={<P6_3_DispatchOrderDetailScreen />} />,
  },
  [WA_Screen.SearchFilter]: {
    key: WA_Screen.SearchFilter,
    path: 'searchFilter',
    mobileComponent: <S3_2_SearchFilter />,
    desktopComponent: <P_Main component={<P5_1_UnaddressedPropertiesMap />} />,
  },
  [WA_Screen.UnadressedWorkplacesList]: {
    key: WA_Screen.UnadressedWorkplacesList,
    path: 'unadressedPropertiesList',
    mobileComponent: <S3_3_UnaddressedPropertiesList />,
    desktopComponent: <P_Main component={<P5_2_UnaddressedPropertiesList />} />,
  },
  [WA_Screen.AddressedWorkplacesList]: {
    key: WA_Screen.AddressedWorkplacesList,
    path: 'adressedPropertiesList',
    mobileComponent: <S4_1_AdressedPropertiesList />,
    desktopComponent: <P_Main component={<P5_2_UnaddressedPropertiesList />} />,
  },
  [WA_Screen.StatusBulkChange]: {
    key: WA_Screen.StatusBulkChange,
    path: 'statusBulkChange',
    mobileComponent: <S4_2_1_StatusBulkChange />,
    desktopComponent: <P_Main component={<S4_2_1_StatusBulkChange />} />,
  },
  [WA_Screen.EditProduct]: {
    key: WA_Screen.EditProduct,
    path: 'editProduct',
    mobileComponent: <S4_3_1_EditProduct />,
    desktopComponent: <P_Main component={<S4_3_1_EditProduct />} />,
  },
  [WA_Screen.ProgressCheck]: {
    key: WA_Screen.ProgressCheck,
    path: 'progressCheck',
    mobileComponent: <S6_1_ProgressCheck />,
    desktopComponent: <P_Main component={<P6_3_DispatchOrderDetailScreen />} />,
  },
  [WA_Screen.BranchSummary]: {
    key: WA_Screen.BranchSummary,
    path: 'branchSummary',
    desktopComponent: <P_Main component={<BranchSummary />} />,
  },
  [WA_Screen.BusinessSummary]: {
    key: WA_Screen.BusinessSummary,
    path: 'businessSummary',
    desktopComponent: <P_Main component={<BusinessSummary />} />,
  },
  [WA_Screen.RecoverySupportMenu]: {
    key: WA_Screen.RecoverySupportMenu,
    path: 'recoverySupportMenu',
    mobileComponent: <S1_2_RecoverySupportMenu />,
    desktopComponent: <P_Main component={<P5_1_UnaddressedPropertiesMap />} />,
  },
  [WA_Screen.UserSearch]: {
    key: WA_Screen.UserSearch,
    path: 'userSearch',
    desktopComponent: <P_Main component={<P4_2_UserSearch />} />,
  },
};
